var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isQB)?_c('div',{attrs:{"id":"app"}},[(_vm.isPlaceHolder)?_c('status-bar',{attrs:{"place-holder":_vm.isPlaceHolder}}):_vm._e(),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }